import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#e2e8f0]">
      <div className="max-w-[87.5rem] mx-auto px-10 py-4 flex items-center justify-between">
        {/* Logo */}
        <div 
          className="cursor-pointer" 
          onClick={() => scrollToSection('hero')}
        >
          <span className="text-[#0f172a] font-bold text-xl tracking-tight uppercase">
            The <span className="text-[#3b82f6]">Real Estate</span> Paralegal
          </span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-2">
          <button 
            onClick={() => scrollToSection('services')}
            className="nav-link text-[#64748b] hover:text-[#0f172a] transition-all duration-300 px-4 py-2 font-medium"
          >
            Services
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="nav-link text-[#64748b] hover:text-[#0f172a] transition-all duration-300 px-4 py-2 font-medium"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="ml-4 bg-[#3b82f6] text-white border-none rounded-[10rem] px-6 py-3 font-semibold text-sm cursor-pointer transition-all duration-300 hover:bg-[#2563eb] hover:scale-[1.02] active:scale-[0.98] uppercase tracking-tight"
          >
            Contact
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-[#0f172a] p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav className="md:hidden bg-white border-t border-[#e2e8f0] px-10 py-6 flex flex-col gap-4">
          <button 
            onClick={() => scrollToSection('services')}
            className="text-[#64748b] hover:text-[#0f172a] transition-all duration-300 py-2 font-medium text-left"
          >
            Services
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="text-[#64748b] hover:text-[#0f172a] transition-all duration-300 py-2 font-medium text-left"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-[#3b82f6] text-white border-none rounded-[10rem] px-6 py-3 font-semibold text-sm cursor-pointer transition-all duration-300 uppercase tracking-tight w-full mt-2"
          >
            Contact
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;
